import { NonFieldError } from "@/components/common/SCAlert";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";
import { UAParser } from "ua-parser-js";

export const Greetings = () => {
  const parser = new UAParser(window.navigator.userAgent);
  const parserResults = parser.getResult();
  const isSupportBrowser = ["Chrome", "Safari"].some((b) =>
    parserResults.browser.name?.includes(b)
  );

  return (
    <>
      {!isSupportBrowser && (
        <Stack spacing={8} sx={{ mx: 4, mt: 4, mb: 0 }} alignItems="center">
          <NonFieldError>
            お使いのブラウザは推奨ブラウザではありません。Google
            ChromeもしくはSafariを開いて、URL「slcp.jp」を入力してアクセスしなおしてください。
          </NonFieldError>
        </Stack>
      )}
      <Stack alignItems="center" sx={{ width: "100%" }}>
        <Stack sx={{ pt: 12, px: 6, pb: 9, gap: 6 }}>
          <Typography
            sx={{
              fontFamily: "Noto Sans JP",
              fontWeight: "700",
              fontSize: "34px",
              lineHeight: "130%",
              letterSpacing: "0.25px",
              textAlign: "center",
              color: "primary.main",
            }}
          >
            睡眠健康測定を
            <br />
            はじめましょう
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Noto Sans JP",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "175%",
              letterSpacing: "0.15px",
              textAlign: "center",
              color: "text.primary",
            }}
          >
            まずは今回の測定に利用する「アカウントの登録」と「事前問診」への回答を行ってください。
          </Typography>
          <Steps />
        </Stack>
        <Stack
          sx={{
            width: "100%",
          }}
        >
          <Stack
            sx={{
              px: 6,
              pb: 10,
              gap: 4,
            }}
          >
            <Button
              component={RouterLink}
              to="/examinee/terms_of_service_agreement"
              variant="contained"
              size="large"
              state="/examinee/signup"
              sx={{ boxShadow: "none", width: "100%" }}
            >
              はじめてご利用の方
            </Button>
            <Stack sx={{ gap: 2 }}>
              <Button
                component={RouterLink}
                to="/examinee/terms_of_service_agreement"
                variant="outlined"
                size="large"
                sx={{ boxShadow: "none", width: "100%" }}
              >
                既にアカウントをお持ちの方
              </Button>
              <Typography
                variant="caption"
                sx={{
                  fontFamily: "Noto Sans JP",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "175%",
                  letterSpacing: "0.4px",
                  textAlign: "center",
                  color: "text.secondary",
                }}
              >
                ※SLEEP COMPASS Lightと共通のアカウントでご利用いただけます。
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          sx={{
            width: "100%",
          }}
        >
          <Stack sx={{ gap: 4, px: 6, pb: 20 }}>
            <Stack
              sx={{
                gap: 2,
                borderRadius: "8px",
                p: 4,
                background: "#0056A00A",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontFamily: "Noto Sans JP",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "190%",
                  letterSpacing: "0.1px",
                  textAlign: "center",
                  color: "primary.main",
                }}
              >
                サービスの位置付け
              </Typography>
              <Typography variant="caption" sx={{ color: "text.primary" }}>
                本サービスは、診断ガイドラインに基づき睡眠時無呼吸症候群・不眠症の疾患リスクをレポートにて表示する場合があります。
                医療機器ではないため、提供される情報や結果は、病気の診断や治療を意図するものではなく、参考情報となります。{" "}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

function Steps() {
  const steps = [
    {
      title: "アカウントの登録",
      image: (
        <img
          src="/img/image_account_register.svg"
          alt="アカウントの登録"
          loading="lazy"
          style={{
            width: "20px",
            height: "24px",
            borderWidth: "1px",
          }}
        />
      ),
    },
    {
      title: "事前問診に回答",
      image: (
        <img
          src="/img/image_primary_interview.svg"
          alt="事前問診に回答"
          loading="lazy"
          style={{
            width: "22px",
            height: "24px",
          }}
        />
      ),
    },
    {
      title: "睡眠測定の開始",
      image: (
        <img
          src="/img/image_start_measurement.svg"
          alt="睡眠測定の開始"
          loading="lazy"
          style={{
            width: "24px",
            height: "24px",
          }}
        />
      ),
    },
  ];
  return (
    <Stack
      sx={{
        gap: "20px",
        paddingTop: "20px",
        paddingRight: "16px",
        paddingBottom: "20px",
        paddingLeft: "16px",
        borderRadius: "8px",
        backgroundColor: "#0056A00A",
      }}
    >
      {steps.map((x, i) => (
        <Fragment key={i}>
          {i > 0 && <Divider />}
          <Stack
            sx={{
              px: 2,
              gap: 4,
              justifyContent: "space-between",
            }}
            direction="row"
          >
            <Stack sx={{ gap: 4 }} direction="row">
              <Typography
                variant="subtitle2"
                sx={{
                  width: "46px",
                  height: "27px",
                  fontFamily: "Noto Sans JP",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "190%",
                  letterSpacing: "0.1px",
                  textAlign: "center",
                  color: "primary.main",
                }}
              >
                STEP {i + 1}
              </Typography>
              <Typography
                sx={{
                  width: "182px",
                  height: "27px",
                  fontFamily: "Noto Sans JP",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "190%",
                  letterSpacing: "0.1px",
                  color: "text.primary",
                }}
              >
                {x.title}
              </Typography>
            </Stack>
            {x.image}
          </Stack>
        </Fragment>
      ))}
    </Stack>
  );
}
